import { render, staticRenderFns } from "./TestCustomPrompt.vue?vue&type=template&id=1b6378ee&scoped=true"
import script from "./TestCustomPrompt.vue?vue&type=script&lang=js"
export * from "./TestCustomPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6378ee",
  null
  
)

export default component.exports